import React, { useState } from "react";
import { toast } from "react-toastify";
import DataGrid from "components/datagrid/DataGrid";
import { Grid } from "@material-ui/core";
import { useStyles } from "../style";
import ConsoleService from "services/admin/masters/Console";
import { MSG_DELETE_SUCCESS } from "constants/admin/masters/users";
import { buildQueryParams } from "utils/common";
import _ from "lodash";

const consoleServiceObj = new ConsoleService();

const ConsoleGrid = (props) => {
    const classes = useStyles();
    const {labId, handleEdit, setActiveBtn, setActivateButton, setVAppId,checkActiveConsoleScreen } = props;
    const [refreshToken, setRefreshToken] = useState(Date.now());
    const [pageSize, setPageSize] = useState(20);
    const metaInfo = {
        columns: [
            { title: "Name", field: "name" },
            // { title: "Description", field: "description" }, will be enable after HTML and URL is integrated in Console
            { title: "Type", field: "type" }
        ],
        actions: [
            {
                icon: "edit",
                tooltip: "Edit Record",
                onClick: (event, rowData) => {
                    handleEdit(rowData, setActiveBtn, setVAppId,checkActiveConsoleScreen)
                },
            },
            {
                icon: "delete",
                tooltip: "Delete Record",
                onClick: (event, rowData) => {
                    handleDelete(rowData)
                },
            },
        ],
    };

    const handlePagingData = (query) => {
        return new Promise((resolve, reject) => {
            let urlParams = { ordering: "-id" }; //default sorting - is used for decending
            if (!_.isEmpty(query.orderBy)) {
                urlParams.ordering = (query.orderDirection === 'desc' ? '-' : '') + query.orderBy.field;
            }
            setPageSize(query.pageSize);
            if (!_.isEmpty(query.filters)) {
                query.filters.map(filter => urlParams[filter.column.field] = filter.value);
            }
            urlParams['limit'] = query.pageSize;
            urlParams['offset'] = query.pageSize * query.page;
            let params = {
                is_deleted: 'false',
                lab: labId
            }
            consoleServiceObj.getAll(buildQueryParams(params)).then((response) => {
                const { results } = response;
                if(results.length!==0){
                    setActivateButton(false)
                }       
                resolve({
                    data: results,
                    page: query.page,
                    totalCount: response.count,
                });
            }).catch(error => {
                console.log(error)
            });
        });
    }

    const handleDelete = (rowData) => {
        consoleServiceObj.delete(rowData?.id).then((response) => {
            toast.success(response.message || MSG_DELETE_SUCCESS);
            setActivateButton(true)
            handleRefresh();
        }).catch(error => {
            console.log(error)
        });
    }

    const handleRefresh = (e) => {
        setRefreshToken(Date.now());
    };

    return (
        <Grid container spacing={1}>

            <Grid item xs={12}>
                <div className={classes.contentGrid}>
                    <DataGrid
                        actions={metaInfo.actions}
                        columns={metaInfo.columns}
                        dataHandler={handlePagingData}
                        filtering={metaInfo.filtering}
                        refreshToken={refreshToken}
                        pageSize={pageSize}
                    ></DataGrid>
                </div>
            </Grid>
        </Grid>
    );
}
export default ConsoleGrid;